"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DataConnectSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4.5,6 C3.67157288,6 3,5.32842712 3,4.5 C3,3.67157288 3.67157288,3 4.5,3 C5.1528467,3 5.70828193,3.41706808 5.91439849,3.99929704 L9.47436306,4 C10.8809065,4 11.9743631,4.95559887 11.9743631,6.5 C11.9743631,7.86989252 10.9903972,8.86405326 9.16512969,9.47194511 C7.67723598,9.9925468 7,10.6697828 7,11.5 C7,12.3253914 7.60087057,12.9258246 8.35659572,12.9936078 L8.5,13 L12.0856015,12.999297 C12.2917181,12.4170681 12.8471533,12 13.5,12 C14.3284271,12 15,12.6715729 15,13.5 C15,14.3284271 14.3284271,15 13.5,15 C12.8467813,15 12.2910851,14.5824565 12.0852495,13.9997075 L8.5,14 C7.1441358,14 6,12.9491472 6,11.5 C6,10.1631896 6.98943069,9.17375894 8.84199627,8.52562165 C10.3087535,8.03708097 10.9743631,7.36457505 10.9743631,6.5 C10.9743631,5.59656519 10.4269154,5.06499383 9.6271949,5.00558209 L9.47436306,5 L5.91475048,4.99970754 C5.70891488,5.58245649 5.15321869,6 4.5,6 Z M13.5,13 C13.2238576,13 13,13.2238576 13,13.5 C13,13.7761424 13.2238576,14 13.5,14 C13.7761424,14 14,13.7761424 14,13.5 C14,13.2238576 13.7761424,13 13.5,13 Z M4.5,4 C4.22385763,4 4,4.22385763 4,4.5 C4,4.77614237 4.22385763,5 4.5,5 C4.77614237,5 5,4.77614237 5,4.5 C5,4.22385763 4.77614237,4 4.5,4 Z" })));
};
DataConnectSmall.displayName = 'DataConnectSmall';
exports.default = DataConnectSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DataConnectSmall.js.map